import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {BlockService} from '../../../service/BlockService';
import { Validation } from '../../../model/validation';
import { MessageService } from '../../../service/message.service';
import { messageTypes } from '../../../helpers/MessageTypes';
import { MAX_DEPASSMENT } from '../../../helpers/GlobalConstants';

@Component({
  selector: 'app-confirmaton-dialog',
  templateUrl: './confirmaton-dialog.component.html',
  styleUrls: ['./confirmaton-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmatonDialogComponent implements OnInit {
  hoursOfProd: any = false;
  user: any;
  loadingIndicator = false;
  breakOverflowDurations: any;
  breakOverflowLimitDepassment: any;
  constructor(public dialogRef: MatDialogRef<ConfirmatonDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private blockservice: BlockService,
              private messageService: MessageService) { }

  ngOnInit() {
    this.user = this.data.user;
    this.hoursOfProd = this.data.hoursOfProd > 10;
    this.breakOverflowDurations = this.data.breakOverflowDurations;
    this.breakOverflowLimitDepassment = this.breakOverflowDurations > MAX_DEPASSMENT;
  }
  public CloseDialog() {
    this.dialogRef.close();
    this.messageService.sendMessage(messageTypes.LOADING);
  }

  public Validation() {
    this.loadingIndicator = true;
    this.blockservice.validationBlockByUser(
      new Validation(this.data.blockIds, this.data.breakOverflowIds, this.data.dateShift),
      () => {
        this.messageService.sendMessage(messageTypes.LOADING);
        this.loadingIndicator = false;
        this.dialogRef.close(true);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/view/block-temps/confirmaton-dialog/confirmaton-dialog.component.ts